
import Link from '@/components/compat/Link';
import { usePathname } from '@/lib/navigation';
import {
  CHANGELOG_PRODUCT_ORDER,
  CHANGELOG_SOURCES,
  type ChangelogProductId,
} from '@/lib/changelog/changelog-sources';
import { changelogPainelBaseHref } from '@/components/painel/changelog/changelog-painel-utils';
import { cn } from '@/lib/utils';

type ChangelogProductTabsProps = {
  product: ChangelogProductId;
  className?: string;
};

export function ChangelogProductTabs({ product, className }: ChangelogProductTabsProps) {
  const pathname = usePathname();
  const suffix = pathname.replace(/^\/painel\/changelog\/(?:xat|ajuda)/, '') || '/overview';

  return (
    <div
      className={cn(
        'inline-flex rounded-full border border-white/10 bg-white/[0.04] p-1 backdrop-blur-sm',
        className
      )}
      role="tablist"
      aria-label="Produto do changelog"
    >
      {CHANGELOG_PRODUCT_ORDER.map((id) => {
        const source = CHANGELOG_SOURCES[id];
        const isActive = product === id;
        const href = `${changelogPainelBaseHref(id)}${suffix === '' ? '/overview' : suffix}`;

        return (
          <Link
            key={id}
            href={href}
            role="tab"
            aria-selected={isActive}
            className={cn(
              'rounded-full px-4 py-2 font-poppins text-sm font-semibold transition-all duration-200',
              isActive
                ? 'bg-gradient-to-r from-sky-500 to-indigo-600 text-white shadow-md shadow-sky-950/40'
                : 'text-slate-300 hover:bg-white/[0.06] hover:text-white'
            )}
          >
            {source.label}
          </Link>
        );
      })}
    </div>
  );
}
